import { mapGetters } from 'vuex';
import mvtArticle from '@/common/components/mvtarticle/mvt-article.vue';
import mortgageTools from '@/staticpages/components/common/mortgagetools/mortgagetools.vue';
import mvtDialogCenter from '@/common/components/mvtdialogcenter/mvt-dialogcenter.vue';
import mvtHeader from '@/common/components/mvtheader/mvt-header.vue';
import mvtFooter from '@/common/components/mvtfooter/mvt-footer.vue';
import { parseQueryString, resolveClickCta } from '@/common/utilities/nojq/_utilities.js';
import { getStorage } from '../../../common/utilities/nojq/_localstorage.js';

export default {
    name: 'pageRentToOwn',
    inject: ['$eventBus'],
    data() {
        return {
            zipcode: '',
            tag: null,
        };
    },
    components: {
        mvtDialogCenter,
        mvtHeader,
        mvtArticle,
        mortgageTools,
        mvtFooter,
    },
    methods: {
        getUtmCTA() {
            let lastSearchedState = this.getState();
            if (['MN', 'MO', 'TX', 'CO', 'AZ', 'OH', 'FL'].includes(lastSearchedState)) {
                return 'renttoown2';
            }
            return '';
        },
        getState() {
            let geoInfo = getStorage('mapsearch.geo');
            return (geoInfo && geoInfo.state) || this.glb.geo.state;
        },
        show3rdPartyForm() {
            if (!this.zipcode || !this.getUtmCTA()) {
                return;
            }
            this.$eventBus.$emit('eventbus-pop-3rdparty', {
                id: this.getUtmCTA(),
                url: 'renttoown',
                zipcode: this.zipcode,
                trigger: this.$options.name,
                cta: resolveClickCta('Apply Now', null, 'SEARCH'),
            });
        },
    },
    computed: {
        ...mapGetters('glb', ['viewport', 'glb', 'getLastSearch']),
    },
    mounted() {
        this.tag = this.glb.articleConfig.tag.preApproval + '';
        this.$eventBus.$emit('eventbus-pageLoaded');
        var winOpt = {};
        if (window && window.location && window.location.search) {
            winOpt = parseQueryString(window.location.search);
        }
        this.zipcode = winOpt.zipcode || '';
        this.show3rdPartyForm();
    },
};
